// =========================================================
// frontend/js/bell.js - Bereinigte Version (V10.1)
// =========================================================
let pendingRequestsCache = [];
/**
 * 1. DATEN LADEN: Holt alle ausstehenden Anträge
 */ async function loadPendingRequests() {
    if (!currentUser || currentUser.role === 'EMPLOYEE' || !currentUser.companyId) return;
    try {
        const snapshot = await db.collection('companies').doc(currentUser.companyId).collection('events').where('status', '==', 'PENDING').get();
        pendingRequestsCache = [];
        snapshot.forEach((doc)=>{
            const event = {
                id: doc.id,
                ...doc.data()
            };
            // Prüfung, ob der User für dieses Team/diese Person zuständig ist
            // (Hier greift dein reportsTo oder Team-Zuständigkeits-Check)
            if (event.reportsTo === currentUser.uid || currentUser.role === 'OWNER' || currentUser.role === 'ADMIN') pendingRequestsCache.push(event);
        });
        updateBellUI();
    } catch (error) {
        console.error("Fehler beim Laden der Benachrichtigungen:", error);
    }
}
/**
 * 2. UI-UPDATE: Aktualisiert den roten Zähler an der Glocke
 */ function updateBellUI() {
    const counterEl = document.getElementById('bell-counter');
    if (!counterEl) return;
    const count = pendingRequestsCache.length;
    if (count > 0) {
        counterEl.innerText = count;
        counterEl.classList.remove('hidden');
    } else counterEl.classList.add('hidden');
}
/**
 * 3. NAVIGATION: Leitet beim Klick auf die Glocke zur Approval-Seite weiter
 */ window.openBellDropdown = function() {
    // Wir wechseln zu den Einstellungen und dort in den Tab "approvals"
    window.activeView = 'settings';
    window.activeSubView = 'approvals';
    window.render();
};
let statusUpdatesCache = []; // Neuer Cache für Feedback an den User
async function loadPendingRequests() {
    if (!currentUser || !currentUser.companyId) return;
    const uid = currentUser.uid;
    try {
        const snapshot = await db.collection('companies').doc(currentUser.companyId).collection('events').get();
        pendingRequestsCache = [];
        statusUpdatesCache = [];
        snapshot.forEach((doc)=>{
            const event = {
                id: doc.id,
                ...doc.data()
            };
            // 1. Sicht für CHEFS: Was muss ich genehmigen?
            if (event.status === 'PENDING' && (event.reportsTo === uid || currentUser.role === 'ADMIN' || currentUser.role === 'OWNER')) pendingRequestsCache.push(event);
            // 2. Sicht für USER: Was wurde für MICH entschieden?
            // Nur wenn Status nicht mehr PENDING ist UND der User noch nicht benachrichtigt wurde
            if (event.userId === uid && event.status !== 'PENDING' && event.userNotified !== true) // Check ob der User das in den Settings überhaupt will
            {
                if (currentUser.settings?.notifyOnStatusChange !== false) statusUpdatesCache.push(event);
            }
        });
        updateBellUI();
    } catch (error) {
        console.error(error);
    }
}
function updateBellUI() {
    const counterEl = document.getElementById('bell-counter');
    if (!counterEl) return;
    // Die Glocke zählt jetzt beides zusammen!
    const count = pendingRequestsCache.length + statusUpdatesCache.length;
    if (count > 0) {
        counterEl.innerText = count;
        counterEl.classList.remove('hidden');
    } else counterEl.classList.add('hidden');
}

//# sourceMappingURL=frontend.8eeb331e.js.map
